import React, { useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Tooltip } from 'react-bootstrap';

const ContainerContact = styled.strong`
  display: flex;
  flex-direction: row;
  font-size: 13px;
  justify-content: center;
  height: 15px;
  color: #1a1a2e;
  transition: all 0.3s ease;

  i {
    font-size: 16px !important;
    margin-left: 5px;
    color: #4b5563;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      color: #1a1a2e;
      transform: scale(1.05);
    }
  }
`;

const handleCopy = (e, text) => {
  e.stopPropagation();

  toast.info(() => (
    <>
      Copiado: <strong style={{ fontWeight: 'bold' }}>{text}</strong>
    </>
  ));
  return navigator.clipboard.writeText(text);
};

const renderTooltip = (props) => (
  <Tooltip id='button-tooltip' {...props}>
    Copiar contato
  </Tooltip>
);

const ContactData = ({ contact }) => (
  <ContainerContact>
    <strong>{contact}</strong>
    <OverlayTrigger
      placement='right'
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <i className='bx bx-copy' onClick={(e) => handleCopy(e, contact)} />
    </OverlayTrigger>
  </ContainerContact>
);

export default ContactData;
